import { HttpClient } from '@trendyol/sc-utils/';
import Interceptors from './Interceptors';

const options = {
  requestInterceptors: [Interceptors.spinnerForRequest],
  responseInterceptors: [Interceptors.spinnerForResponse, Interceptors.errorHandlerForResponse],
  injectTokenHeaderRequestInterceptor: true,
  injectTokenRefreshResponseInterceptor: true,
  eventBus: window.scEventBus || {},
};

export const SellerCenterSellerApiClient = new HttpClient(
  process.env.VUE_APP_SELLER_BFF,
  options,
);

export const SellerCenterAccountApiClient = new HttpClient(
  process.env.VUE_APP_ACCOUNT_BFF,
  options,
);

export const SellerCenterSSOApiClient = new HttpClient(
  process.env.VUE_APP_SSO_BFF,
  options,
);

export const PublicSellerCenterSSOApiClient = new HttpClient(
  process.env.VUE_APP_SSO_BFF,
  {
    ...options,
    injectTokenHeaderRequestInterceptor: false,
    injectTokenRefreshResponseInterceptor: false,
  }
);

export const PublicSellerCenterAccountApiClient = new HttpClient(
  process.env.VUE_APP_ACCOUNT_BFF,
  {
    ...options,
    injectTokenHeaderRequestInterceptor: false,
    injectTokenRefreshResponseInterceptor: false,
  }
);
export const SPRGWApiClient = new HttpClient(process.env.VUE_APP_SPR_GW, options);
